import { CircleUserRoundIcon } from 'lucide-react-native';
import { iconWithClassName } from './iconWithClassName';

iconWithClassName(CircleUserRoundIcon);
export { CircleUserRoundIcon };
